<div class="td-wb-pagination">
  <h2 class="td-wb-vh"
      translate="tdWb.pagination.ARIA_HEADER"></h2>
  <div class="td-wb-pagination__list">

    <!-- Previous page button -->
    @if (!hideArrows()) {
      <div class="td-wb-pagination__prev">
        <button type="button"
                class="td-wb-pagination__navigation-button"
                [attr.disabled]="isFirstPage() ? '' : null"
                [attr.aria-label]="'tdWb.pagination.PREVIOUS_PAGE' | translate"
                (click)="onPageClick(selectedPage() - 1)">
          <td-wb-icon [class.td-wb-pagination__icon--disabled]="isFirstPage()"
                      iconId="caret-left"
                      size="18"/>
        </button>
      </div>
    }

    <!-- Pages -->
    @for (pageNumber of pages(); track $index) {
      <div [class]="getPageSelectorButtonClass(pageNumber)">
        @if (pageNumber !== undefined) {
          <button class="td-wb-pagination__button"
                  type="button"
                  [attr.aria-pressed]="selectedPage() === pageNumber"
                  (click)="onPageClick(pageNumber)"
                  [textContent]="pageNumber + 1">
          </button>
        }
        @if (pageNumber === undefined) {
          <div>&sdot;&sdot;&sdot;</div>
        }
      </div>
    }

    <!-- Next page button-->
    @if (!hideArrows()) {
      <div class="td-wb-pagination__next">
        <button class="td-wb-pagination__navigation-button"
                type="button"
                [attr.disabled]="isLastPage() ? '' : null"
                [attr.aria-label]="'tdWb.pagination.NEXT_PAGE' | translate"
                (click)="onPageClick(selectedPage() + 1)">
          <td-wb-icon [class.td-wb-pagination__icon--disabled]="isLastPage()"
                      iconId="caret-right"
                      size="18"/>
        </button>
      </div>
    }
  </div>
</div>
